import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'vxnK5F',
    defaultMessage: 'How do you manage your inventory?',
    description: 'Title for inventory management section',
  },
  description: {
    id: 'rXtLQa',
    defaultMessage: "ShipStation's inventory management features simplify and automate your inventory workflows",
    description: 'Description for inventory management section',
  },
  selectOption: {
    id: 'SCdya7',
    defaultMessage: 'Select an Inventory Management Method',
    description: 'Default title for inventory management dropdown',
  },
  spreadsheet: {
    id: 'j/Olxe',
    defaultMessage: 'I use spreadsheets',
    description: 'Option for managing inventory using spreadsheets',
  },
  manualManagement: {
    id: 'p1zLsu',
    defaultMessage: 'I manually manage my inventory',
    description: 'Option for manually managing inventory without spreadsheets',
  },
  externalIMS: {
    id: 'eRzoqS',
    defaultMessage: 'I use inventory management software (IMS)',
    description: 'Option for using an external inventory management system',
  },
  shopifyIMS: {
    id: '6rofCf',
    defaultMessage: 'I use Shopify',
    description: 'Option for managing inventory through Shopify',
  },
  noManagement: {
    id: '9TWkBK',
    defaultMessage: "I haven't decided",
    description: 'Option for users who have not decided on inventory management',
  },
});
